(function () {
  if (!('IntersectionObserver' in window)) return;

  const loadedSections = new Set();

  const loadScript = (src) => {
    return new Promise((resolve) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      document.body.appendChild(script);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      const section = el.dataset.section;
      const script = el.dataset.script;

      if (!section || loadedSections.has(section)) return;

      loadedSections.add(section);

      if (script) {
        await loadScript(script);
        document.dispatchEvent(
          new CustomEvent(`section:${section}:load`, { detail: el })
        );
      }

      observer.unobserve(el);
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('[data-lazy-section]').forEach((el) => {
    observer.observe(el);
  });
})();
